import React, { Component } from 'react';

class About extends Component {
   render() {
      if (this.props.data) {
         var name = this.props.data.name;
         var profilepic1 = "images/" + this.props.data.profilepic1;
         var profilepic2 = "images/" + this.props.data.profilepic2;
         var profilepic3 = "images/" + this.props.data.profilepic3;
         var softwareMantra = this.props.data.softwareMantras[Math.floor(Math.random() * this.props.data.softwareMantras.length)];;
         var bio = this.props.data.bio;
         var street = this.props.data.address.street;
         var city = this.props.data.address.city;
         var state = this.props.data.address.state;
         var zip = this.props.data.address.zip;
         var phone = this.props.data.phone;
         var email = this.props.data.email;
         var resumeDownload = this.props.data.resumedownload;
      }

      return (
         <section id="about">
            <div className="row">
               <div className="three columns pull-left profile-pics">
                  <img className="profile-pic" src={profilepic1} alt="Devin Mochrie Profile Pic" />
                  <img className="profile-pic" src={profilepic2} alt="Devin Mochrie Profile Pic" />
                  <img className="profile-pic" src={profilepic3} alt="Devin Mochrie Profile Pic" />
               </div>
               <div className="nine columns main-col">
                  <h2>Programming is like...</h2>
                  <p>{softwareMantra}</p>
                  <h2>About Me</h2>
                  <p>{bio}</p>
                  <div className="row">
                     <div className="columns contact-details">
                        <div className="contact-wrapper">
                           <div className="address">
                              <h2>Contact Details</h2>
                              <span>{name}</span><br />
                              <span>{street}<br />
                                 {city} {state}, {zip}
                              </span><br />
                              <span>{phone}</span><br />
                              <span>{email}</span>
                           </div>
                           <div className="columns download">
                              <a href={resumeDownload} target="_blank" id="downloadButton" className="button">
                                 <i className="fa fa-download"></i>Download Resume
                              </a>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      );
   }
}

export default About;



// WEBPACK FOOTER //
// ./src/Components/About.js